import React, { useContext, useEffect, useState } from 'react';
import { Trans, useLingui } from '@lingui/react';
import { useNavigate } from 'react-router-dom';
import { TransButtonDefault, TransButtonDefaultWithIcon, TransButtonPrimaryWithIcon, TransButtonPrimaryWithSpinner } from '../../Atoms/Buttons';
import { ModalDialog, useModalState } from '../../Molecules/Dialogs';
import { getForSend } from '../../Utils/utils';
import { findUnresolvablePlaceholders } from '../../Service/restapi/placeholderService';
import { WindowContext } from '../../Service/Context/WindowContext';
import EditableDateInput from '../../Atoms/inputs/EditableDateInput';
import { CheckLicence } from '../../Organismns/Upgrade/CheckLicence';
import { patchDraft } from '../../Service/restapi/messageService';
import { scheduleMail } from '../../Service/restapi/scheduledMailService';
import { ToastS } from '../../Service/ToastS';

const ScheduleMail = ({
  message,
  focusedNodeRef,
  changeEmailById,
  setEmailAction,
  customer,
  event,
  eventLocation,
  customAttributeValues,
  saveMailDraftCallback,
}) => {
  const { i18n } = useLingui();
  const [isPlaning, setPlaning] = useState(false);
  const { show, toggle } = useModalState(false);
  const { windowWidth } = useContext(WindowContext);
  const [plainMail, setPlainMail] = useState(undefined);
  const [scheduledTime, setScheduledTime] = useState(undefined);
  const navigate = useNavigate();

  useEffect(() => {
    if (show) {
      // setPlainMail(undefined);
    }
  }, [show]);

  function toggleDialog(patch) {
    setPlainMail(undefined);
    const m = getForSend(message, patch, i18n, customer, event, eventLocation, customAttributeValues);
    m.scheduledMailId = message.scheduledMailId;

    if (!m.subject) {
      ToastS.warn('subject.required', 'Bitte gib einen Betreff an');
    } else if (!m.to) {
      ToastS.warn('recipient.required', 'Bitte gib einen Empfänger an');
    } else {
      saveMailDraftCallback();

      findUnresolvablePlaceholders(m.subject, m.message).then((resp) => {
        if (resp.ok) {
          setPlainMail(m);
          toggle();
        } else if (resp.status === 412) {
          ToastS.cleanAll();
          ToastS.error('find.unresolved.placeholders', 'E-Mail enthält nicht ersetzbare Platzhalter');
          resp.json().then((json) => {
            json.forEach((placeholder) => {
              const translation = i18n._(placeholder, { 0: 1 });
              ToastS.error(`placeholder.unsatisfied-${translation}`, i18n._(`${translation} nicht gesetzt`));
            });
          });
        }
      });
    }
  }

  function saveAndSchedule() {
    if (focusedNodeRef.current) {
      const name = focusedNodeRef.current.getAttribute('name');
      const value = focusedNodeRef.current.innerHTML;
      const patch = {
        [name]: value,
      };
      toggleDialog(patch);
    } else {
      toggleDialog();
    }
  }

  function schedule() {
    if (!scheduledTime) {
      ToastS.warn('schedule.required', 'Bitte wähle wann die E-Mail gesendet werden soll');
    } else {
      setPlaning(true);
      // plainMail.scheduledTime = scheduledTime;
      console.log({ plainMail });
      patchDraft(plainMail.id, plainMail).then((resp) => {
        if (resp.ok) {
          scheduleMail(plainMail.id, scheduledTime)
            .then((resp) => {
              if (resp.ok) {
                ToastS.cleanAll();
                ToastS.success('schedule.email', 'E-Mail erfolgreich geplant');
                setEmailAction(undefined);

                resp.json().then((messageDto) => {
                  changeEmailById(messageDto.id, messageDto);
                  if (event) {
                    navigate(`/events/${event.id}/emails/scheduled`);
                  } else {
                    navigate('/postbox/scheduled');
                  }
                });
              } else if (resp.status === 412) {
                ToastS.error('schedule.email', 'Geplante Zeit lag in der Vergangenheit');
              } else {
                ToastS.error('schedule.email', 'E-Mail konnte nicht geplant werden');
              }
            })
            .catch((error) => {
              console.error({ error });
              ToastS.error(
                'schedule.email',
                'E-Mail konnte nicht geplant werden. Bitte überprüfe Deine Internetverbindung.',
              );
            })
            .finally(() => {
              setPlainMail(undefined);
              setPlaning(false);
              toggle();
            });
        }
      });
    }
  }

  return (
    <div style={{ marginLeft: 5, marginRight: 5 }}>
      <CheckLicence
        id="scheduleMail"
        buttonComponent={TransButtonPrimaryWithIcon}
        // buttonText={windowWidth > 1200 ? 'actions.schedule' : undefined}
        icon="CLOCK"
        style={{ color: '#666666', fontSize: 12, minWidth: 32 }}
        onClick={saveAndSchedule}
        licence="FLOW"
        upgradeTitle="E-Mails planen"
        className="primary-link-new"
        upgradeText={
          'Schreibe Deine E-Mails Stunden, Tage oder sogar Jahre vorher,\n' +
          'um Deinem Kunden z.B. einen weiteren Fragebogen zukommen zu lassen oder zum Hochzeitstag zu gratulieren und Dich so noch einmal in Erinnerung zu rufen.\n'
        }
      />
      <ModalDialog
        header={<Trans id="E-Mail planen" />}
        body={
          <EditableDateInput
            finishCallback={(p) => {
              setScheduledTime(p.sharedUntil);
              return Promise.resolve();
            }}
            showTimeSelect
            value={scheduledTime}
            patchField="sharedUntil"
            labelStyle={{ color: '#9ca6af', fontWeight: 'unset' }}
            placeholder="E-Mail senden um"
          />
        }
        footer={
          <div>
            <TransButtonPrimaryWithSpinner
              isLoading={isPlaning}
              onClickHandler={!isPlaning ? schedule : null}
              text="actions.ok"
            />{' '}
            <TransButtonDefault onClickHandler={toggle} text="actions.cancel" />
          </div>
        }
        show={show}
        toggle={toggle}
      />
    </div>
  );
};

export default ScheduleMail;
